// extracted by mini-css-extract-plugin
module.exports = {"DefaultDroppableList":"DraggingWrappers_DefaultDroppableList__35qjL"};